export function getStartOfDay(date: Date = new Date()): Date {
   return new Date(new Date(date).setHours(0, 0, 0, 0));
}

export function getEndOfDay(date: Date = new Date()): Date {
   return new Date(new Date(date).setHours(23, 59, 59, 999));
}